import axios from "axios";
import { useContext } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { OperaContext } from "../../../../context/OperaContext";

export default function BasePriceEdit(event) {
    const { fetchAdminData } =
        useContext(OperaContext);
    const { register, handleSubmit, formState: { errors } } = useForm({
        defaultValues: {
            basePrice: event.event.basePrice || 0,
        },
    });
    const onSubmit = async (data) => {
        const basePrice = parseFloat(data.basePrice);
        if (basePrice === event.event.basePrice) {
            return;
        }
        let dataSave = new FormData();
        dataSave.append("basePrice", isNaN(basePrice) ? "0" : basePrice.toString());
        const formattedDateTimes = event?.event?.date_times.map((dt) => {
            try {
                const date = new Date(dt.date);
                const [hours, minutes] = (dt.time || "19:00").split(":");
                date.setHours(parseInt(hours) || 19, parseInt(minutes) || 0, 0, 0);
                return { date: date.toISOString(), cost: dt.cost || "0" };
            } catch (error) {
                console.error("Error formatting date/time:", error, dt);
                // Fallback to a default date/time
                const fallbackDate = new Date();
                fallbackDate.setHours(19, 0, 0, 0);
                return fallbackDate.toISOString();
            }
        });

        dataSave.append("date_times", JSON.stringify(formattedDateTimes));
        dataSave.append("title", event?.event?.title.trim());
        dataSave.append("venue", event?.event?.venue?._id);

        try {
            const url = `/api/events/${event.event._id}`;
            const method = "put";
            const token = localStorage.getItem("token");
            const res = await axios({
                method,
                url,
                data: dataSave,
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: token ? `Bearer ${token}` : "",
                },
                timeout: 15000,
                withCredentials: true,
            });
            if (res.status === 200) {
                toast.success("Successfully updated base price.");
                fetchAdminData();
            }
        } catch (err) {
            toast.error(
                `Error saving event: ${err.response?.data?.message || err.message}`
            );
        }
    };

    return (
        <div>
            <div className="flex gap-2">
                <p onBlur={handleSubmit(onSubmit)}>
                    <strong>Base price: </strong>
                    <input
                        type="number"
                        {...register("basePrice", {
                            required: "Base price is required",
                            min: { value: 0, message: "Price cannot be negative" },
                        })}
                        className="text-white bg-[#1a1a1a] !w-fit"
                        onWheel={(e) => e.target.blur()}
                    />
                    {errors.basePrice && <span style={{ color: "red" }}>{errors.basePrice.message}</span>}
                </p>
            </div>
        </div>
    )
}
